const { request } = require("../../../rest/index");
const pick = require("lodash/pick");

const getAddons = (productId, options) => {
  return request
    .get(
      `/website-api/v1/products/${productId}/addons`,
      pick(options, [
        "countryPrefix",
        "locale",
        "gender",
        "cover",
        "box",
        "size",
        "format_identifier",
      ])
    )
    .then((res) => res.body);
};

module.exports = {
  getAddons,
};
